module.exports = __webpack_public_path__ + "files/2efb89b243c10cb4f7a50ee9208cb511.png";